<template>
  <div class="ai-detail-talk-mobile">
    <div class="tab-box__left-body">
      <template v-for="(talk, index) in chatList" :key="index">
        <div class="talk-item" @click="openTalk(talk.start)">
          <div class="talk-item-avatar">
            <div
              class="avatar"
              :style="{
                backgroundColor: getAvatar(talk.speakUser).color
              }"
            >
              {{ getAvatar(talk.speakUser).name }}
            </div>
          </div>
          <div class="talk-item-content">
            <div class="talk-item-content__top">
              <div class="name">{{ talk.speakUser }}</div>
              <div class="time">{{ formatTime(talk.start) }}</div>
            </div>
            <div class="talk-item-content__box" :class="{ 'is-risk': talk.riskStatus === 1 }">
              {{ talk.text }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { getAvatar } from '@/utils/ai-talk'

defineOptions({
  name: 'AiDetailTalkMobile'
})

const emits = defineEmits(['startWithTime'])

const props = defineProps({
  chatList: {
    type: Array,
    default: () => []
  },
  isAudio: {
    type: Boolean,
    default: false
  },
  inxbbQuickView: {
    type: Boolean,
    default: false
  }
})

const formatTime = (seconds) => {
  const totalSeconds = Math.floor(seconds)
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = totalSeconds % 60

  return [
    h.toString().padStart(2, '0'),
    m.toString().padStart(2, '0'),
    s.toString().padStart(2, '0')
  ].join(':')
}

const openTalk = (time) => {
  if (props.isAudio) {
    emits('startWithTime', time)
  }
}
</script>

<style lang="scss" scoped>
.ai-detail-talk-mobile {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 0;
  :deep(.van-sticky) {
    background: #ffffff !important;
  }
  .tab-box__left-top {
    flex: 0 0 auto;
    display: flex;
    margin-bottom: 16px;
    i {
      margin-right: 8px;
      background: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .text {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #323233;
    }
  }
  .tab-box__left-body {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .talk-item {
      display: flex;
      margin-bottom: 16px;
      border-radius: 8px;
      cursor: pointer;
      &:active {
        background: #f2f3f5;
      }
      .talk-item-avatar {
        margin-right: 12px;
        .avatar {
          width: 24px;
          height: 24px;
          border-radius: 8px;
          color: #ffffff;
          font-size: 12px;
          font-weight: 600;
          text-align: center;
          line-height: 24px;
        }
      }
      .talk-item-content {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        line-height: 20px;
        .talk-item-content__top {
          display: flex;
          .name {
            color: #646566;
            margin-right: 8px;
          }
          .time {
            color: #969799;
            cursor: pointer;
          }
        }
        .talk-item-content__box {
          color: #323233;
          margin-top: 4px;
        }
        .is-risk {
          background: #ffece8;
        }
      }
    }
  }
  .tab-box__left-bottom {
    flex: 0 0 auto;
    height: 48px;
    margin-top: 16px;
  }
}
</style>
